module.exports = __webpack_public_path__ + "img/sniper.f02eb298.svg";